/* === Seashell: female/male model toggle — v2 ===================================
   Supersedes the v1 block still sitting in seashell-custom.js.

   WHY: v1 attached click handlers directly to .seashell-model-toggle and hid
   slides with inline styles. Shopify re-renders the product info + gallery on
   every variant change, which (a) threw the handlers away, so the toggle
   silently stopped responding, and (b) replaced the slides, dropping the inline
   display:none — so every image, male and female, reappeared at once. Switching
   male -> female landed exactly in that window.

   HOW v2 fixes it:
   - clicks are handled by ONE delegated listener on document, so a re-rendered
     toggle is still live;
   - visibility is driven by [data-ss-gender] on the gallery + [data-ss-g] on
     each slide via !important CSS, not per-element inline styles;
   - a MutationObserver re-tags and re-asserts after any re-render;
   - the slider/dots reset only runs on a real click, not on re-assertion, so
     re-rendering can't thrash the carousel.

   v1 IS NEUTRALISED, NOT DELETED: this file is loaded BEFORE seashell-custom.js
   in layout/theme.liquid, so its DOMContentLoaded handler runs first and stamps
   dataset.wired on every toggle. v1's init() early-returns on that flag, so it
   never attaches a listener and the two cannot fight. If you ever delete the v1
   block from seashell-custom.js, this file keeps working unchanged.
   ============================================================================ */
(function(){
  var STYLE_ID = 'ss-model-toggle-css';
  var state = {};          /* section|product -> gender */
  var applying = false;
  var pending = null;

  function injectCSS(){
    if(document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent =
      '[data-ss-gender="female"] .product__media[data-ss-g="male"],' +
      '[data-ss-gender="female"] .product__thumbnail[data-ss-g="male"],' +
      '[data-ss-gender="male"] .product__media[data-ss-g="female"],' +
      '[data-ss-gender="male"] .product__thumbnail[data-ss-g="female"],' +
      '[data-ss-gender] .product__media[data-ss-dup="1"]' +
      '{display:none!important}';
    (document.head || document.documentElement).appendChild(s);
  }

  function genderOfAlt(a){
    a = (a || '').toLowerCase();
    if(/\bfemale\b/.test(a)) return 'female';   /* female tested first: "female" contains "male" */
    if(/\bmale\b/.test(a))   return 'male';
    return 'both';                               /* untagged media (incl. video) shows for both */
  }

  function keyFor(t){
    return (t.getAttribute('data-section') || '') + '|' + (t.getAttribute('data-product') || '');
  }
  function galleryFor(t){
    return document.getElementById('ProductGallery-' + t.getAttribute('data-section') + '-' + t.getAttribute('data-product'));
  }

  function tagAll(gallery){
    gallery.querySelectorAll('.product__media-list .product__media, .product__thumbnail').forEach(function(it){
      var img = it.querySelector('img');
      var g = genderOfAlt(img && img.getAttribute('alt'));
      if(it.dataset.ssG !== g) it.dataset.ssG = g;
    });
  }

  function firstMatching(gallery, gender){
    var slides = gallery.querySelectorAll('.product__media-list .product__media');
    for(var i = 0; i < slides.length; i++){
      var g = slides[i].dataset.ssG || 'both';
      if(g === 'both' || g === gender) return slides[i];
    }
    return null;
  }

  function apply(toggle, gender, userAction){
    var gallery = galleryFor(toggle);
    if(!gallery) return;
    applying = true;
    try{
      injectCSS();
      tagAll(gallery);
      state[keyFor(toggle)] = gender;
      gallery.setAttribute('data-ss-gender', gender);

      var preview = gallery.querySelector('.product__preview .product__media');
      if(preview){
        if(preview.dataset.ssOrigId === undefined){
          preview.dataset.ssOrig   = preview.innerHTML;
          preview.dataset.ssOrigId = preview.getAttribute('data-media-id') || '';
          var p0 = preview.querySelector('img');
          preview.dataset.ssOrigG  = genderOfAlt(p0 && p0.getAttribute('alt'));
        }
        var og = preview.dataset.ssOrigG || 'both';
        if(og === 'both' || og === gender){
          if(preview.getAttribute('data-media-id') !== preview.dataset.ssOrigId){
            preview.innerHTML = preview.dataset.ssOrig;
            preview.setAttribute('data-media-id', preview.dataset.ssOrigId);
          }
        } else {
          var fv = firstMatching(gallery, gender);
          if(fv && fv.getAttribute('data-media-id') !== preview.getAttribute('data-media-id')){
            preview.innerHTML = fv.innerHTML;
            preview.setAttribute('data-media-id', fv.getAttribute('data-media-id'));
            var pi = preview.querySelector('img');
            if(pi){ pi.loading = 'eager'; pi.setAttribute('loading','eager'); }
          }
        }
        /* Don't show the preview image twice — but ONLY while .product__preview is
           actually rendered. On mobile (and on the desktop even-grid layout) the
           preview is hidden and the list IS the gallery, so skipping a slide there
           would drop the main image. */
        var dupId = (preview.offsetParent !== null) ? preview.getAttribute('data-media-id') : null;
        gallery.querySelectorAll('.product__media-list .product__media').forEach(function(s){
          if(dupId && s.getAttribute('data-media-id') === dupId){ s.dataset.ssDup = '1'; }
          else if(s.dataset.ssDup){ delete s.dataset.ssDup; }
        });
      }

      var smd = document.querySelector('.seashell-model-details');
      if(smd){
        var mf = smd.querySelector('.smd-female'), mm = smd.querySelector('.smd-male');
        if(gender === 'male' && mm){ if(mf) mf.style.display = 'none'; mm.style.display = ''; }
        else { if(mm) mm.style.display = 'none'; if(mf) mf.style.display = ''; }
      }

      /* re-query every time — the toggle node may have been replaced */
      document.querySelectorAll('.seashell-model-toggle').forEach(function(t){
        if(keyFor(t) !== keyFor(toggle)) return;
        t.dataset.wired = '1';
        t.querySelectorAll('button[data-gender]').forEach(function(b){
          var on = b.getAttribute('data-gender') === gender;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      });

      /* Only reset the carousel on a real click. Doing it on every re-assertion
         is what made the gallery flicker and lose its place. */
      if(userAction){
        var list = gallery.querySelector('.product__media-list');
        if(list){ try{ list.scrollTo({left:0}); }catch(e){ list.scrollLeft = 0; } }
        var sl = gallery.querySelector('slider-element');
        if(sl){ try{ (sl.reset || sl.update || function(){}).call(sl); }catch(e){} }
        var dots = gallery.querySelector('media-dots');
        if(dots && dots.resetIndexes){ try{ dots.resetIndexes(); }catch(e){} }
        try{ window.dispatchEvent(new Event('resize')); }catch(e){}
      }
    } finally {
      applying = false;
    }
  }

  function applyAll(userAction){
    document.querySelectorAll('.seashell-model-toggle').forEach(function(t){
      apply(t, state[keyFor(t)] || 'female', !!userAction);
    });
  }

  /* delegated — survives any number of re-renders */
  document.addEventListener('click', function(e){
    if(!e.target || !e.target.closest) return;
    var b = e.target.closest('.seashell-model-toggle button[data-gender]');
    if(!b) return;
    var t = b.closest('.seashell-model-toggle');
    if(t) apply(t, b.getAttribute('data-gender'), true);
  });

  function reassert(){
    if(applying || pending) return;
    pending = setTimeout(function(){ pending = null; applyAll(false); }, 90);
  }

  var mo = new MutationObserver(reassert);
  function observe(){
    document.querySelectorAll('.seashell-model-toggle').forEach(function(t){
      var g = galleryFor(t);
      if(g && !g.dataset.ssObs){ g.dataset.ssObs = '1'; mo.observe(g, {childList:true, subtree:true}); }
    });
    var info = document.querySelector('product-info, .product__info');
    if(info && !info.dataset.ssObs){ info.dataset.ssObs = '1'; mo.observe(info, {childList:true, subtree:true}); }
  }

  function boot(){
    /* claim the toggles before v1's DOMContentLoaded handler sees them */
    document.querySelectorAll('.seashell-model-toggle').forEach(function(t){ t.dataset.wired = '1'; });
    applyAll(false);
    observe();
  }

  if(document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  document.addEventListener('shopify:section:load', function(){ observe(); reassert(); });
  window.addEventListener('pageshow', function(){ reassert(); });
})();
